module.exports = __webpack_public_path__ + "static/img/p15.77130550.png";